module.exports = __webpack_public_path__ + "img/appointmentBg.53b9266e.png";